/* W6-7 — tekstpagina's (voorwaarden/privacy/policies), identiek bestand op beide sites.
   Progressive enhancement, inhoud blijft byte-gelijk (er wordt nooit tekst gewijzigd, alleen
   classes/attributen/wrappers toegevoegd en bestaande knopen verplaatst):
   1. strong-alinea's die als kop fungeren (heel <p> = één <strong>) krijgen class .rw-rte__h + anker-id;
   2. "Laatst bijgewerkt"-openingsregel wordt als meta-regel gestyled (class, geen tekstwijziging);
   3. een in de tekst opgenomen "Inhoudsopgave" (Artikel 1 …) wordt een ankerlijst (.rw-rte-toc);
   4. zonder in-tekst-inhoudsopgave: "Op deze pagina" — sticky rechts (>=1100px) en als
      inklapbaar blok bovenaan op smallere schermen;
   5. tabellen: kolomkoppen als data-label (gestapelde weergave <640px) of scroll-affordance;
   6. "Naar boven"-knop na anderhalf scherm scrollen;
   7. /policies/*: de breadcrumb uit de layout schuift in de Shopify-container (zelfde kolom als de H1). */
(function () {
  var scope = document.querySelector('.rw-textpage article, .shopify-policy__container');
  if (!scope) return;
  var rte = scope.querySelector('.rte');
  if (!rte) return;

  function slug(txt, i) {
    return (txt || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'sectie-' + i;
  }
  function norm(txt) { return (txt || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // 7. policies: breadcrumb in dezelfde kolom als de titel
  var policyHead = document.querySelector('.rw-policyhead');
  if (policyHead && scope.classList.contains('shopify-policy__container')) {
    var crumb = policyHead.querySelector('.rw-breadcrumb');
    if (crumb) scope.insertBefore(crumb, scope.firstChild);
    policyHead.parentNode.removeChild(policyHead);
  }

  // 2. meta-regel (alleen presentatie)
  var firstP = rte.querySelector('p');
  if (firstP && /^laatst bijgewerkt/i.test((firstP.textContent || '').trim())) {
    firstP.classList.add('rw-textpage__meta');
  }
  // r5: één metadatanotatie op alle juridische pagina's ("Laatst bijgewerkt op D maand JJJJ") — puur presentatie
  var metaEl = document.querySelector('.rw-textpage__meta');
  if (metaEl) {
    var MND = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
    var mm = (metaEl.textContent || '').match(/laatst bijgewerkt\s*(?:op|:)?\s*(\d{1,2})-(\d{1,2})-(\d{4})/i);
    if (mm) {
      var mi = parseInt(mm[2], 10) - 1;
      if (mi >= 0 && mi < 12) metaEl.textContent = 'Laatst bijgewerkt op ' + parseInt(mm[1], 10) + ' ' + MND[mi] + ' ' + mm[3];
    } else {
      var mt = (metaEl.textContent || '').match(/laatst bijgewerkt\s*:\s*(.+)$/i);
      if (mt) metaEl.textContent = 'Laatst bijgewerkt op ' + mt[1].trim();
    }
  }

  // 1. strong-alinea's als kop markeren
  rte.querySelectorAll('p').forEach(function (p) {
    if (p.children.length === 1 && p.children[0].tagName === 'STRONG' &&
        p.textContent.trim() === p.children[0].textContent.trim() &&
        p.textContent.trim().length > 2 && p.textContent.trim().length < 120) {
      p.classList.add('rw-rte__h');
    }
  });

  // koppen + ankers
  var heads = Array.prototype.slice.call(rte.querySelectorAll('h2, p.rw-rte__h'));
  heads = heads.filter(function (h) { var t = (h.textContent || '').trim(); return t.length > 2 && !/^inhoudsopgave/i.test(t); });
  var used = {};
  heads.forEach(function (h, i) {
    if (!h.id) {
      var id = slug(h.textContent, i);
      while (used[id] || document.getElementById(id)) id += '-' + i;
      used[id] = 1; h.id = id;
    }
  });

  // 3. in-tekst-inhoudsopgave (r3): visueel verbergen — de standaard "Op deze pagina"-navigatie
  // (sticky rail op desktop, inklapbaar blok op mobiel) is op ALLE lange teksten hetzelfde systeem.
  // De alinea's blijven in de DOM (tekst byte-gelijk; zonder JS gewoon zichtbaar).
  var tocHead = Array.prototype.filter.call(rte.querySelectorAll('p'), function (p) { return /^inhoudsopgave/i.test((p.textContent || '').trim()); })[0];
  if (tocHead && heads.length >= 3) {
    var items = [];
    var el = tocHead.nextElementSibling;
    while (el && el.tagName === 'P' && (/^artikel\s*\d+/i.test(norm(el.textContent)) || !norm(el.textContent)) && !el.classList.contains('rw-rte__h')) { items.push(el); el = el.nextElementSibling; }
    if (items.length >= 3) {
      tocHead.classList.add('rw-rte-srctoc');
      items.forEach(function (p) { p.classList.add('rw-rte-srctoc'); });
    }
  }

  // 4. "Op deze pagina" (alleen als de tekst zelf geen inhoudsopgave heeft)
  var links = {};
  if (heads.length >= 3) {
    var wrap = scope.closest('.rw-textpage') || scope;
    var list = '<ol>' + heads.map(function (h) { return '<li><a href="#' + h.id + '">' + esc(h.textContent) + '</a></li>'; }).join('') + '</ol>';
    var toc = document.createElement('aside');
    toc.className = 'rw-textpage__toc';
    toc.setAttribute('aria-label', 'Op deze pagina');
    toc.innerHTML = '<p class="rw-textpage__toc-h">Op deze pagina</p>' + list;
    wrap.classList.add('rw-textpage--toc');
    wrap.appendChild(toc);
    // mobiel/tablet: inklapbaar blok direct boven de tekst
    var det = document.createElement('details');
    det.className = 'rw-textpage__tocm';
    det.innerHTML = '<summary>Op deze pagina <span class="rw-textpage__tocm-n">(' + heads.length + ')</span></summary>' + list;
    // r5: de collapsible landt ONDER de meta-regel, ook als die (policies) ín de rte staat
    if (metaEl && metaEl.parentNode === rte) { rte.insertBefore(det, metaEl.nextSibling); } else { rte.parentNode.insertBefore(det, rte); }
    det.addEventListener('click', function (e) { if (e.target.closest('a')) det.removeAttribute('open'); });
    toc.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
  }
  if ('IntersectionObserver' in window && Object.keys(links).length) {
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          if (current) current.classList.remove('is-active');
          current = links[en.target.id];
          if (current) current.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  }

  // 5. tabellen: kolomkoppen als label (stapelen op smalle schermen), anders scroll-affordance
  rte.querySelectorAll('table').forEach(function (t) {
    var rows = t.querySelectorAll('tr');
    if (!rows.length) return;
    var hrow = t.tHead ? t.tHead.rows[0] : rows[0];
    var hcells = hrow ? Array.prototype.slice.call(hrow.children) : [];
    var allTh = hcells.length >= 2 && hcells.every(function (c) { return c.tagName === 'TH'; });
    if (allTh) {
      var labels = hcells.map(function (c) { return (c.textContent || '').trim(); });
      Array.prototype.forEach.call(rows, function (r) {
        if (r === hrow) { r.classList.add('rw-tbl__hrow'); return; }
        Array.prototype.forEach.call(r.children, function (c, i) { if (labels[i]) c.setAttribute('data-label', labels[i]); });
      });
      t.classList.add('rw-tbl--stack');
    } else {
      var mark = function () { t.classList.toggle('is-scrollable', t.scrollWidth > t.clientWidth + 2); };
      mark(); window.addEventListener('resize', mark);
      t.addEventListener('scroll', function () { t.classList.toggle('is-scrolled', t.scrollLeft > 4); }, { passive: true });
    }
  });

  // 6. naar boven
  var top = document.createElement('button');
  top.type = 'button';
  top.className = 'rw-totop';
  top.setAttribute('aria-label', 'Naar boven');
  top.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="m5 12 7-7 7 7"/></svg>';
  top.addEventListener('click', function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'instant' : 'smooth' });
    var h1 = document.querySelector('h1'); if (h1) { h1.setAttribute('tabindex', '-1'); h1.focus({ preventScroll: true }); }
  });
  document.body.appendChild(top);
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { top.classList.toggle('is-on', window.scrollY > window.innerHeight * 1.5); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
